module.exports = __webpack_public_path__ + "static/photos-5ad8cb1a5e0a93098ac5fa936d9f1de8.png";